// Mock data for A To Z Infraspares Landing Page

export const heroData = {
  headline: "Stop Searching. Start Moving.",
  subheadline: "The Ultimate One-Stop Shop for Earthmoving and Stone Crusher Spares.",
  description: "Eliminate downtime with India's most comprehensive inventory. With 8 strategic locations and a dedicated team of 50+ experts, we deliver the high-performance parts you need—exactly when and where you need them. From A to Z, we've got you covered.",
  ctaText: "Request a Quote",
  secondaryCtaText: "Download Portfolio",
  heroImage: "/hero-quarry.png"
};

export const problemData = {
  title: "Is a Single Missing Part Costing You Thousands per Hour?",
  description: "In the earthmoving and stone crushing industry, downtime is the enemy. When a machine stops, your revenue stops. Most businesses struggle with:",
  problems: [
    {
      icon: "PackageX",
      title: "Fragmented Suppliers",
      description: "Wasting days sourcing different parts from multiple unreliable vendors."
    },
    {
      icon: "Clock",
      title: "Shipping Delays",
      description: "Waiting for weeks for 'out-of-stock' components to arrive from distant warehouses."
    },
    {
      icon: "AlertTriangle",
      title: "Quality Risks",
      description: "Settling for sub-par spares that lead to even costlier secondary breakdowns."
    }
  ]
};

export const solutionData = {
  title: "Your All-In-One Infrastructure Partner",
  description: "At A To Z Infraspares, we live by our name. We've built an ecosystem designed to keep your heavy machinery running at peak efficiency without the logistical headache.",
  features: [
    {
      icon: "Package",
      title: "Massive Ready Inventory",
      description: "We don't just 'order' parts; we stock them. Our 8 nationwide locations mean your spares are likely already around the corner.",
      image: "https://images.unsplash.com/photo-1685483749753-0dab7e144794?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHx3YXJlaG91c2UlMjBwYXJ0cyUyMGludmVudG9yeSUyMGluZHVzdHJpYWwlMjBzdG9yYWdlfGVufDB8fHx8MTc3NjAwMDkxOHww&ixlib=rb-4.1.0&q=85"
    },
    {
      icon: "Building2",
      title: "The 'One Roof' Advantage",
      description: "Why manage ten vendors when you can manage one? We provide everything from heavy-duty belts to precision bearings.",
      image: "https://images.unsplash.com/photo-1469289759076-d1484757abc3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHx3YXJlaG91c2UlMjBwYXJ0cyUyMGludmVudG9yeSUyMGluZHVzdHJpYWwlMjBzdG9yYWdlfGVufDB8fHx8MTc3NjAwMDkxOHww&ixlib=rb-4.1.0&q=85"
    },
    {
      icon: "Users",
      title: "Expert Support",
      description: "Our team of 50+ professionals doesn't just sell parts—they provide solutions based on decades of industry expertise.",
      image: "https://images.unsplash.com/photo-1759763823587-c8bd07fca246?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwZW5naW5lZXIlMjB0ZWFtJTIwd29ya2VycyUyMG1hY2hpbmVyeXxlbnwwfHx8fDE3NzYwMDA5MTl8MA&ixlib=rb-4.1.0&q=85"
    }
  ]
};

export const brandsData = {
  title: "World-Class Engineering for Maximum Durability",
  description: "We partner with the industry's most trusted names to ensure your machinery handles the toughest terrains and heaviest loads.",
  brands: [
    {
      name: "JM3",
      logo: "/logos/jm3.png",
      tagline: "PERFORMANCE MATTERS",
      specialization: "Elite Spherical Roller Bearings, specialized lubricants, and tooth points for heavy machinery.",
      categories: ["Bearings", "Lubricants", "Tooth Points"]
    },
    {
      name: "ITR",
      logo: "/logos/itr.png",
      tagline: "PASSION FOR PARTS",
      specialization: "Premium undercarriage, ground engaging tools, and hydraulic parts for all major earthmoving machinery.",
      categories: ["Undercarriage", "Ground Engaging Tools", "Hydraulic Parts"]
    },
    {
      name: "RIS",
      logo: "/logos/ris.png",
      tagline: "",
      specialization: "High-strength Conveyor Rollers and Frames built to last.",
      categories: ["Conveyor Rollers", "Frames"]
    },
    {
      name: "Q+",
      logo: "/logos/qplus.png",
      tagline: "The New Language of earth movers",
      specialization: "Advanced seal kits, rock breakers, rock buckets, and pin bushing solutions.",
      categories: ["Seal Kits", "Rock Breakers", "Pin Bushing"]
    },
    {
      name: "HINDUSTAN EAGLE",
      logo: null,
      tagline: "Conveyor Belting",
      specialization: "Ultra-durable, heavy-duty conveyor belts for extreme mining environments.",
      categories: ["Conveyor Belting"]
    },
    {
      name: "Donaldson",
      logo: "/logos/donaldson.png",
      tagline: "Filtration Solutions",
      specialization: "World-leading filtration solutions to protect your engines and extend equipment life.",
      categories: ["Filters"]
    },
    {
      name: "JK Fenner",
      logo: "/logos/jkfenner.png",
      tagline: "",
      specialization: "High-precision transmissions and Vee Belts for seamless power delivery.",
      categories: ["Transmission", "Vee Belts"]
    },
    {
      name: "Gates",
      logo: "/logos/gates.png",
      tagline: "",
      specialization: "Premium Hose Pipe and fittings for long lasting operations.",
      categories: ["Hose Pipe", "Fittings"]
    },
    {
      name: "Marathon Motors",
      logo: "/logos/marathon.png",
      tagline: "",
      specialization: "High performance industrial motor solutions.",
      categories: ["Industrial Motors"]
    },
    {
      name: "TVS",
      logo: "/logos/tvs.png",
      tagline: "",
      specialization: "Industrial fasteners and precision components for heavy equipment assembly.",
      categories: ["Fasteners"]
    },
    {
      name: "GROZ",
      logo: "/logos/groz.png",
      tagline: "",
      specialization: "Professional-grade tools and equipment for maintenance and servicing.",
      categories: ["Tools & Equipment"]
    }
  ]
};

export const socialProofData = {
  title: "Trusted by the Titans of Industry",
  description: "We don't just claim excellence; we prove it daily on-site. Our reputation is built on speed, reliability, and the sheer scale of our operations.",
  stats: [
    {
      icon: "MapPin",
      value: "8",
      label: "Strategic Hubs",
      description: "For lightning-fast dispatch"
    },
    {
      icon: "Users",
      value: "50+",
      label: "Specialized Team Members",
      description: "Ready to assist"
    },
    {
      icon: "Star",
      value: "20+",
      label: "Years of Trust",
      description: "Reliable brand legacy"
    }
  ],
  reviewLink: "https://www.google.com/search?client=safari&rls=en&q=a+to+z+infraspares+pvt.+ltd.+reviews&ie=UTF-8&oe=UTF-8",
  backgroundImage: "https://images.pexels.com/photos/4487363/pexels-photo-4487363.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
};

export const faqData = {
  title: "Frequently Asked Questions",
  faqs: [
    {
      question: "How quickly can you deliver spares to my site?",
      answer: "With 8 inventory locations across the region, we offer some of the fastest turnaround times in the industry. Most 'common' spares are available for immediate dispatch."
    },
    {
      question: "Do you really provide 'A to Z' requirements for stone crushers?",
      answer: "Yes! From the conveyor belts (PR Hindustan) and rollers (RIS) to the bearings (JM3) and lubricants (Servo), we provide every component required to keep a crushing plant operational under one roof."
    },
    {
      question: "Are these parts genuine replacements?",
      answer: "Absolutely. We are authorized partners for world-renowned brands like ITR and Donaldson, ensuring that every part meets or exceeds OEM specifications."
    },
    {
      question: "How do I know which part is right for my specific machinery model?",
      description: "Our team of 50+ versatile members includes technical experts who can help identify the exact part number and specification for your specific make and model."
    },
    {
      question: "How can I get a formal quotation?",
      answer: "You can reach us directly via the contact details below, and our sales team will provide a competitive quote within 24 hours."
    }
  ]
};

export const contactData = {
  companyName: "A To Z Infraspares Pvt Ltd",
  email: "enquiry@atozinfraspares.com",
  phone: "+91 94154 56760"
};

// Mock form submission handlers
export const handleQuoteRequest = (formData) => {
  console.log("Quote Request Submitted:", formData);
  return {
    success: true,
    message: "Thank you! We'll send you a quote within 24 hours."
  };
};

export const handleContactForm = (formData) => {
  console.log("Contact Form Submitted:", formData);
  return {
    success: true,
    message: "Thank you for contacting us! We'll get back to you soon."
  };
};

export const handleDownloadPortfolio = () => {
  console.log("Portfolio Download Requested");
  return {
    success: true,
    message: "Portfolio download will be available soon!"
  };
};
